// extracted by mini-css-extract-plugin
export default {"modal":"jha-z","modalContent":"kha-z","footer":"lha-z","cancelBtn":"mha-z","disabled":"nha-z","formWrapper":"oha-z","fade":"pha-z","fade-in":"qha-z","iframe":"rha-z"};